import messages from './extensionLibrary-tag-message';
export default [
    {tag: 'music', intlLabel: messages.music},
    {tag: 'pen', intlLabel: messages.pen},
    {tag: 'video', intlLabel: messages.video},
    {tag: 'text', intlLabel: messages.text},
    {tag: 'translate', intlLabel: messages.translate}
];
